const { Equation } = require('../../functionalities')

function SOtoFO(SO) {
	return new Equation(SO)
}
module.exports = SOtoFO